export default function CurrentState({ children }) {
  return (
    <div className="current-state">
      <p>{children}</p>
    </div>
  );
}
